import WavesIcon from "@material-ui/icons/Waves";
import BindingCompanyList from "./BindingCompanyList";

export default {
  list: BindingCompanyList,
  icon: WavesIcon,
};
